<form class="container">
    <div class="sub-container">
        <div class="form grid">
            <p class="default-text ps-title-grid">Defina o tipo e o rótulo que ficarão nos campos do login no portal.</p>
            <div [formGroup]="form" class="fields">
                <div fxLayout.lt-lg="column" fxLayout="row" class="fields-session" formArrayName="fields">
                    <div class="input-content" *ngFor="let field of fields.controls; let i = index" [formGroupName]="i">
                        <p class="default-text ps-text-field">Campo {{i + 1}}</p>
                        <mat-form-field appearance="fill" class="input-login">
                            <mat-label>Tipo de login</mat-label>
                            <mat-select formControlName="type" required>
                                <mat-option *ngFor="let item of options" [value]="item.type">
                                    {{item.name}}
                                </mat-option>
                            </mat-select>
                            <span></span>
                            <mat-hint class="mat-hint-form">Escolha o formato de entrada que será aceito no campo</mat-hint>
                            <mat-error *ngIf="form.get(['fields', i, 'type']).hasError('required')">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="fill" class="input-login default-margin-input">
                            <mat-label>Rótulo</mat-label>
                            <input matInput type="text" formControlName="label" required>
                            <span></span>
                            <mat-hint class="mat-hint-form">Defina o nome que será exibido como rótulo deste campo.</mat-hint>
                            <mat-error *ngIf="form.get(['fields', i, 'label']).hasError('required')">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
        <mat-divider [vertical]="true"></mat-divider>
        <div class="preview grid">
            <div class="preview-grid-title">
                <p class="default-text preview-text">Pré-visualização</p>
            </div>
            <div class='simulation-login'>
                <div class="title-silulation-login">
                    <p class="default-text">Login</p>
                </div>
                <div>
                    <div class="preview-input">
                        <div class="ps-content-inputs-preview">
                            <div class="ps-row-inputs" fxLayout="row" fxLayoutGap="8px"
                                *ngFor="let field of fields.controls; let i = index">

                                <div fxFlex *ngIf="!field.value.type">
                                    <mat-form-field appearance="fill" fxFlex class="field-infix-width-auto">
                                        <mat-label>{{field.value.label || 'Exemplo'}}</mat-label>
                                        <input matInput type="text">
                                    </mat-form-field>
                                </div>

                                <div fxFlex *ngIf="field.value.type == 'text'">
                                    <mat-form-field appearance="fill" fxFlex class="field-infix-width-auto">
                                        <mat-label>{{field.value.label || 'Exemplo'}}</mat-label>
                                        <input matInput type="text">
                                    </mat-form-field>
                                </div>
                                <div fxFlex *ngIf="field.value.type == 'date'">
                                    <mat-form-field appearance="fill" fxFlex class="field-infix-width-auto">
                                        <mat-label>{{field.value.label || 'Exemplo'}}</mat-label>
                                        <input matInput type="text" mask="00/00/0000">
                                    </mat-form-field>
                                </div>
                                <div fxFlex *ngIf="field.value.type == 'number'">
                                    <mat-form-field appearance="fill" fxFlex class="field-infix-width-auto">
                                        <mat-label>{{field.value.label || 'Exemplo'}}</mat-label>
                                        <input matInput type="number">
                                    </mat-form-field>
                                </div>
                                <div fxFlex *ngIf="field.value.type == 'cpf'">
                                    <mat-form-field appearance="fill" fxFlex class="field-infix-width-auto">
                                        <mat-label>{{field.value.label || 'Exemplo'}}</mat-label>
                                        <input matInput type="text" mask="000.000.000-00">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div classfxLayout="column">
                            <mat-divider [inset]="true"></mat-divider>
                            <div fxLayout="row" class="ps-dialog-content-actions" fxLayoutAlign="end end">
                                <div fxFlex fxLayoutAlign="end end">
                                    <a class="ps-input-preview-cancel" mat-stroked-button>
                                        Cancelar
                                    </a>
                                    <button mat-raised-button color="primary">
                                        Acessar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-save-editions [form]="form" (emitSubmit)="onDialog()" [date]="data"
        (clickClearAlternateChanges)="resetValidation()" [custumSubmit]="true" [clearForm]="false"
        [marginCustom]="'ps-custom-margin-save-editions'">
    </app-save-editions>
</form>
